import {
  type FormValidationOptions,
  type ProgramTheme,
  type VerificationResponse,
  type ViewModel,
} from "../types/types";

/** Derives form validation options from the effective theme, response, and view model. */
export const selectFormValidationOptions = (
  programTheme: ProgramTheme | undefined,
  verificationResponse: VerificationResponse | undefined,
  viewModel: ViewModel | undefined,
): FormValidationOptions => ({
  minAge: verificationResponse?.minAge || programTheme?.config?.minAge,
  maxAge: verificationResponse?.maxAge || programTheme?.config?.maxAge,
  smsLoopEnabled: programTheme?.smsLoopEnabled,
  strictMilitaryValidationEnabled: programTheme?.strictMilitaryValidationEnabled,
  transitionalMilitaryValidityDays: programTheme?.transitionalMilitaryValidityDays,
  currentStep: verificationResponse?.currentStep,
  viewModel,
});
